import React from 'react';
import LazyPageLoader from "../../components/LazyPageLoader.tsx";

const Page = React.lazy(()=>import('./DropzoneUploader_Internal'));

export default function DropzoneUploader({onUpload, parent_id}){
    return <React.Suspense fallback={<LazyPageLoader />}>
        <Page onUpload={onUpload} parent_id={parent_id} />
    </React.Suspense>
}



